
import { Vue, Component } from 'vue-property-decorator'
import { getuserCurrentApp } from '@/utils/cookies'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import updateConfigDialog from '@/views/config/remind/updateDialog.vue'
import ConfigLogDialog from '../configLog.vue'

@Component({
  name: 'remind',
  components: {
    updateConfigDialog,
    ConfigLogDialog
  }
})
export default class extends Vue {
  private tableData = []
  private node = {}

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getGlobalConfig()
  }

  private getGlobalConfig() {
    const params = {
      app_id: this.userCurrentApp
    }
    CONFIGAPI.getGlobalConfig(params).then((res) => {
      if (res.stat === 1) {
        this.tableData = res.data
      }
    })
  }

  private handleUpdate(scope: any) {
    // ConfigModule.setGlobalConfigOptions(data)
    this.node = scope.row
    ConfigModule.ToggleDialogStatus({
      name: 'globalConfigDialog',
      value: true
    })
  }

  // 查看操作日志
  handleShowLog() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: true
    })
  }

  private handleSuccess() {
    this.$nextTick(() => {
      this.getGlobalConfig()
    })
  }
}
